<div class="filter-group">
  <div class="filter-group__header">
    <div class="filter-group__title">
      {{ 'filters.usageSpace.label' | i18n }}
      <span class="filter-group__title__unit">(m<sup>2</sup>)</span>
    </div>

    <button class="filter-group__reset" *ngIf="canReset" (click)="reset()">
      {{ 'filters.common.reset' | i18n }}
    </button>
  </div>

  <div class="filter-group__main">
    <lib-range-slider
      [options]="options"
      [minOption]="currentFilter.min"
      [maxOption]="currentFilter.max"
      (minChange)="selectMin($event)"
      (maxChange)="selectMax($event)"
    >
    </lib-range-slider>
  </div>
</div>
